import { render, staticRenderFns } from "./MessageImpacta.vue?vue&type=template&id=1bd7a338&scoped=true"
import script from "./MessageImpacta.vue?vue&type=script&lang=js"
export * from "./MessageImpacta.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bd7a338",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1bd7a338')) {
      api.createRecord('1bd7a338', component.options)
    } else {
      api.reload('1bd7a338', component.options)
    }
    module.hot.accept("./MessageImpacta.vue?vue&type=template&id=1bd7a338&scoped=true", function () {
      api.rerender('1bd7a338', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Flujo/Final/MessageImpacta.vue"
export default component.exports